import React, { forwardRef, ReactNode, useRef } from 'react';
import * as S from './DesktopFilterAccordion.styles';
import { adjustScrollPosition } from './DesktopFilterAccordion.helpers';
import { Accordion, AccordionRef } from '@/components/UI/Accordion/Accordion';
import { SearchResultsPageTestIds } from '@/__e2e__/testIds/search-results-page';

interface Props {
  title: string;
  value?: string | null;
  search?: ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
  onClear: () => void;
  dataTestId?: string;
}

export const DesktopFilterAccordion = forwardRef<AccordionRef, Props>(
  (
    { title, value, search, defaultOpen, children, onClear, dataTestId },
    ref
  ) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    function handleClear(event: React.MouseEvent) {
      event.stopPropagation();
      onClear();
    }

    function handleOpen() {
      adjustScrollPosition(wrapperRef);
    }

    return (
      <div ref={wrapperRef} data-testid={dataTestId}>
        <Accordion
          ref={ref}
          title={title}
          contentHead={search}
          subTitle={
            value && (
              <S.SubtitleContainer>
                {value}{' '}
                <S.ClearButton
                  onClick={handleClear}
                  data-testid={
                    SearchResultsPageTestIds.desktopFilters.clearButton
                  }
                />
              </S.SubtitleContainer>
            )
          }
          maxHeight={330}
          defaultOpen={defaultOpen}
          onOpen={handleOpen}
        >
          {children}
        </Accordion>
      </div>
    );
  }
);

DesktopFilterAccordion.displayName = 'DesktopFilterAccordion';
